export const MILESTONE_TYPE = {
    NONE: 'None',
    WORKFLOW: 'Workflow',
    MILESTONE_PAY: 'Milestone pay',
    WORK_PROCESS: 'Work Process',
    RECURRING: 'Recurring',
};
